<template>
  <v-simple-table>
    <caption>
      <strong>{{ item.title }}</strong>
    </caption>
    <tbody>
      <tr v-for="object in item.list" :key="object.name">
        <td class="opacity-6">{{ object.name }}</td>
        <td>{{ object.value }}</td>
      </tr>
    </tbody>
  </v-simple-table>
</template>
<script>
export default {
  props: {
    item: Object
  }
};
</script>
<style scoped>
.opacity-6 {
  color: rgba(0, 0, 0, 0.6);
}
</style>
